import React from "react";

const VideoBarPersonMicOn = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 13C8 18.3333 18 18.3333 18 13" stroke="#2BC138" />
      <path
        d="M16 8.02673C16 6.35511 14.6568 5 13 5C11.3431 5 10 6.35511 10 8.02673V11.9733C10 13.6449 11.3432 15 13 15C14.6569 15 16 13.6449 16 11.9733V8.02673Z"
        fill="#2BC138"
      />
      <rect x="12" y="17" width="2" height="3" fill="#44BF37" />
    </svg>
  );
};

export default VideoBarPersonMicOn;
